export default __webpack_public_path__ + "static/media/dp.4b3b730c.png";